'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function(TimeoutCategory2) {
  TimeoutCategory2[TimeoutCategory2["ONE_DAY"] = 1] = "ONE_DAY";
  TimeoutCategory2[TimeoutCategory2["ONE_WEEK"] = 2] = "ONE_WEEK";
  TimeoutCategory2[TimeoutCategory2["ONE_MONTH"] = 3] = "ONE_MONTH";
})(exports.TimeoutCategory || (exports.TimeoutCategory = {}));
